import { useAppSelector } from '@/state/hooks';
import { Notification, selectNotifications } from '@/state/reducers/notificationSlice';
import { useMemo } from 'react';

interface UseNotificationsProps {}
interface UseNotificationsReturn {
    notifications: Notification[];
    unseenNotifications: Notification[];
    seenNotifications: Notification[];
    allCount: number;
    seenCount: number;
    unseenCount: number;
}

const useNotifications = (props: UseNotificationsProps): UseNotificationsReturn => {
    const notifications = useAppSelector(selectNotifications);

    const unseenNotifications = useMemo(
        () => notifications.filter((notification) => !notification.seen),
        [notifications]
    );
    const seenNotifications = useMemo(() => notifications.filter((notification) => notification.seen), [notifications]);
    const allCount = useMemo(() => notifications.length, [notifications]);
    const seenCount = useMemo(() => seenNotifications.length, [seenNotifications]);
    const unseenCount = useMemo(() => unseenNotifications.length, [unseenNotifications]);

    return {
        notifications,
        unseenNotifications,
        seenNotifications,
        allCount,
        seenCount,
        unseenCount
    };
};

export default useNotifications;
